<template>
  <v-footer app class="app-footer pt-4 grey darken-4">
    <h1 class="h2 ml-auto mr-auto white--text font-weight-regular">
      My Menu Cloud
    </h1>
    <div class="app-download d-flex align-center ml-auto mr-auto">
      <a
        class="mr-2"
        href="https://apps.apple.com/jp/app/my%E3%83%A1%E3%83%8B%E3%83%A5%E3%83%BC%E3%82%AF%E3%83%A9%E3%82%A6%E3%83%89/id1465902295?itsct=apps_box&itscg=30200"
        ><img
          src="@/assets/appstore.svg"
          alt="iOSアプリダウンロード"
          width="115"
      /></a>
      <a
        href="https://play.google.com/store/apps/details?id=jp.stealthcloud.menu_android"
        ><img
          src="@/assets/googleplay.png"
          alt="Androidアプリダウンロード"
          width="155"
      /></a>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.app-download {
  position: absolute;
  top: 10px;
  right: 20px;
}

@media screen and (max-width: 840px) {
  .app-footer {
    position: relative;
  }

  .app-download {
    position: relative;
    top: auto;
    right: auto;
    margin-top: 10px;
  }
}
</style>